import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;

const Description = styled.p`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

const CtaButton = styled.button`
  align-self: flex-end;
  padding: 12px 20px;
  border-radius: 8px;
  border: none;
  background-color: ${({ theme }) => theme.colors.button.surface.primary};
  color: ${({ theme }) => theme.colors.button.text.primary};
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 16.94px;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.button.surface.primary};
    outline-offset: 2px;
  }
`;

export const ResaleDateModal: FC = () => {
  const { translate } = useI18nContext();
  const { toggleModal } = useModalContext();
  const navigate = useNavigate();
  const { eventId } = useParams<{ eventId: string }>();

  const handleCta = () => {
    toggleModal({ open : false });
    navigate(`/resale/event/${eventId}`);
  };

  return (
    <Body>
      <Description>{translate(['RESALE', 'DATE_MODAL', 'BODY'])}</Description>
      <CtaButton onClick={handleCta}>
        {translate(['RESALE', 'DATE_MODAL', 'CTA'])}
      </CtaButton>
    </Body>
  );
};
